import JourneyStartColor from './JourneyStartColour.svg';
import JourneyStartDark from './JourneyStartDark.svg';
import JourneyStartLight from './JourneyStartLight.svg';
export const journeyStart = { color: JourneyStartColor, dark: JourneyStartDark, light: JourneyStartLight };
//# sourceMappingURL=index.js.map